{
  "nl": {
    "issue": {
      "actions": {
        "approve_for_customer": "Zelf goedkeuren voor de klant",
        "cancel_approval": "Annuleer goedkeuring klant",
        "collapse": "Sluit alle punten",
        "create_category": "Maak nieuwe categorie",
        "create_issue": "Maak punt aan",
        "create_issue_customer": "Meld defect",
        "delete": "Verwijder punt",
        "expand": "Open alle punten",
        "export_images": "Afbeeldingen downloaden",
        "hideActivity": "Verberg activiteit",
        "hideDetails": "Details verbergen",
        "openConversation": "Gesprek openen",
        "reject_for_customer": "Afwijzen voor de klant",
        "request_approval": "Verzoek goedkeuring klant",
        "show": "Toon punt",
        "showActivity": "Toon activiteit",
        "showDetails": "Details tonen",
        "startConversation": "Gesprek beginnen",
        "start_conversation": "Begin gesprek over dit punt",
        "undo_customer_approval": "De goedkeuring van de klant ongedaan maken",
        "undo_customer_rejection": "De afwijzing van de klant ongedaan maken",
        "update": "Bewerk punten"
      },
      "attributes": {
        "approval_status": "Goedkeuring klant",
        "assignee": "Aangestelde",
        "category": "Categorie",
        "created_at": "Gemaakt",
        "deadline": "Deadline",
        "description": "Omschrijving",
        "issue_list_type": "Puntenlijst",
        "name": "Onderwerp",
        "responsible": "Verantwoordelijke",
        "status": "Status",
        "statuses": {
          "approval_not_requested": "Niet Gevraagd",
          "approval_requested": "Aangevraagd",
          "approved": "Goedgekeurd",
          "completed": "Voltooid",
          "created": "Open",
          "declined": "Afgewezen",
          "inbox": "Verzonden",
          "not_completed": "Niet Voltooid",
          "ongoing": "In behandeling"
        },
        "updated_at": "Laatste update"
      },
      "edit_actions": {
        "edit_category": "Categorie",
        "edit_deadline": "Deadline",
        "edit_issue_list_type": "Puntenlijst",
        "edit_responsible": "Verantwoordelijke",
        "edit_status": "Status"
      },
      "labels": {
        "activity": "Activiteit",
        "addImagesSubtitle": "A picture says more than a thousand words",
        "addImagesTitle": "Voeg afbeeldingen toe, dit helpt ons het defect nog beter begrijpen",
        "after_care_page_title": "Punten",
        "all_categories_can_be_managed_under": "Alle categorieën kunnen worden beheerd onder",
        "approvalNotRequested": "Goedkeuring niet aangevraagd",
        "approvalRequested": "Goedkeuring gevraagd",
        "approved": "Goedgekeurd",
        "approvedInfo": "Klant keurde dit punt goed",
        "assignee": "Verantwoordelijke",
        "cancelCustomerApproval": "Annuleer aanvraag klantengoedkeuring",
        "collapse": "Verberg activiteit",
        "company_settings": "bedrijfsinstellingen",
        "count_edit": "Bewerk punt | Bewerk {count} punten",
        "create_new_category?": "Vind je niet de categorie die je nodig hebt? Maak een nieuwe!",
        "created_at": "Gemaakt op",
        "customerApproved": "Goedgekeurd door klant",
        "customerRejected": "Afgewezen door klant",
        "deadline_date": "Deadline",
        "description": "Beschrijving",
        "descriptionSubtitle": "Gebruik opsommingstekens en korte zinnen om het voor ons gemakkelijker te maken het defect te begrijpen",
        "descriptionTitle": "Geef een korte omschrijving",
        "edit_category": "Categorie bewerken",
        "edit_issue": "Bewerk punt",
        "isThisPointFixed": "Is dit opgelost voor jou?",
        "issue_category_name": "Categorie",
        "issue_status_name": "Status",
        "issues_selected": "geselecteerde snags",
        "name": "Naam",
        "new": "Maak nieuw punt",
        "new_category": "Nieuwe categorie",
        "noDescriptionYet": "Nog geen beschrijving",
        "no_issue_deadline": "Geen deadline",
        "no_issues": "Geen punten",
        "no_responsible": "Geen verantwoordelijke",
        "origin": "Oorsprong",
        "reason": "Reden",
        "redoRequest": "Goedkeuring opnieuw aanvragen",
        "requestCustomerApproval": "Vraag klantengoedkeuring aan",
        "requested": "Aangevraagd",
        "requestedInfo": "Goedkeuring gevraagd aan de klant",
        "resetRequest": "Goedkeuringsverzoek annuleren",
        "responsible_of_Employee_type_last_name_or_responsible_of_Partner_type_last_name": "Aansprakelijk",
        "return_to_overview": "Ga terug",
        "showIssuesfor": "Toon punten voor",
        "statusExplained": "Wat elk van de statuskleuren betekenen",
        "subjectSubtitle": "Slechts 1 melding nodig per defect. Wij zorgen voor de rest",
        "subjectTitle": "Beschrijf het defect in een paar woorden",
        "undoCustomerApproved": "Goedkeuring door klant ongedaan maken",
        "unit_issues_will_be_shown_here": "Alle units die aan deze lijst worden toegevoegd, zullen hier zichtbaar zijn.",
        "unit_name": "Unit naam",
        "updated_at": "Laatste update",
        "waitingForApproval": "Dit punt moet eerst worden geaccepteerd door {client_name} voordat je een gesprek kunt beginnen",
        "whyIsThisPointNotFixed": "Waarom is dit punt niet opgelost voor jou?",
        "youApprovedThisPoint": "Opgelost voor jou",
        "youRejectedThisPoint": "Niet opgelost voor jou"
      },
      "placeholders": {
        "customers": {
          "none": {
            "subtitle": "Vanaf het moment dat een medewerker een defect voor deze unit meldt, zal deze hier te zien zijn.",
            "title": "Er zijn nog geen defecten gemeld voor deze unit."
          }
        },
        "employees": {
          "inbox": {
            "subtitle": "Wanneer klanten nieuwe punten maken, worden ze hier opnieuw weergegeven.",
            "title": "Je hebt alle inkomende punten van klanten verwerkt"
          },
          "none": {
            "subtitle": "Noteer wat hersteld of verbeterd moet worden.",
            "title": "Voeg je eerste punt toe"
          },
          "overview": {
            "subtitle": "Maak je eerste punt in een unit om aan de slag te gaan",
            "title": "Punten die in al je units zijn gemaakt, worden hier weergegeven"
          },
          "unit": {
            "title": "Alle punten voor deze unit zullen hier worden getoond"
          }
        },
        "partners": {
          "none": {
            "subtitle": "Vanaf het moment dat je bent toegewezen aan punten, zullen ze hier zichtbaar zijn.",
            "title": "Nog geen punten toegewezen aan jou."
          }
        }
      },
      "sortGroups": {
        "date": "Datum",
        "deadline": "Deadline",
        "name": "Naam"
      },
      "toasts": {
        "update": "Punt gewijzigd"
      },
      "validation": {
        "issue_list_type_required": "Puntenlijst is vereist",
        "pleaseProvideAReason": "Geef een reden",
        "status_required": "Status is verplicht"
      }
    }
  }
}